export default __webpack_public_path__ + "static/media/wellcom.4ff19f8d.svg";